import { render } from "./App.vue?vue&type=template&id=1c78c0bf&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1c78c0bf&lang=css"
import "./App.vue?vue&type=style&index=1&id=1c78c0bf&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__